export const nodeWidth = 200;
export const processorStepHeight = 35;
export const stageStepHeight = 26;
export const processorXPadding = 50;
export const processorYPadding = 50;
export const linkPadding = 8;
export const inputConnectorSpace = 22;
